// Module
var code = `<h2 class="section-header">DepEd file upload history</h2>
  <table class="table" at-table at-list="\$ctrl.history">
    <thead></thead>
    <tbody class="tbody">
    <tr class="products-table__row">
      <td at-title="No.">{{\$index+1}}</td>
      <td at-title="File id">{{item.attachedFileId}}</td>
      <td at-title="Uploaded on">{{item.uploadedOn | prettyDate}}</td>
      <td at-title="File name">{{item.fileName}}</td>
      <td at-title="File size">{{item.byteSize}} B</td>
      <td at-title="Rows count">{{item.rowsCount}}</td>
      <td>
        <button
          type="button"
          class="btn btn-primary"
          ng-click="\$ctrl.seeDetails(item)">
          Details
        </button>
      </td>
    </tr>
    </tbody>
  </table>

  <div ng-if="!\$ctrl.history || !\$ctrl.history.length" class="empty-message">
    <span>DepEd payment file upload history is blank</span>
  </div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/deped/batch-deped-history-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;